module.exports = "/assets/data/f962c49166cae8150f50dac36af68832-LN1.data.json";